import { cn } from "@/lib/utils";
import {
  PULSING,
  STATUS_TONE,
  type Status,
  statusLabel,
  TONE_BADGE,
  TONE_DOT,
  type Tone,
} from "../lib/status";
import { Badge } from "./ui/badge";

export function StatusDot({ tone, pulse, className }: { tone: Tone; pulse?: boolean; className?: string }) {
  return (
    <span className={cn("relative inline-flex size-2 shrink-0", className)} aria-hidden="true">
      {pulse && (
        <span
          className={cn(
            "absolute inline-flex size-full animate-ping rounded-full opacity-60",
            TONE_DOT[tone],
          )}
        />
      )}
      <span className={cn("relative inline-flex size-2 rounded-full", TONE_DOT[tone])} />
    </span>
  );
}

export function StatusBadge({ status, className }: { status: Status; className?: string }) {
  const tone = STATUS_TONE[status] ?? "neutral";
  return (
    <Badge variant="outline" className={cn("gap-1.5", TONE_BADGE[tone], className)}>
      <StatusDot tone={tone} pulse={PULSING.has(status)} />
      {statusLabel(status)}
    </Badge>
  );
}

export function ToneBadge({
  tone,
  children,
  className,
  title,
}: {
  tone: Tone;
  children: React.ReactNode;
  className?: string;
  title?: string;
}) {
  return (
    <Badge variant="outline" title={title} className={cn(TONE_BADGE[tone], className)}>
      {children}
    </Badge>
  );
}

/** A small dot in an agent's or section's own colour from the factory config. */
export function ColorDot({ color, className }: { color: string; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-block size-2.5 shrink-0 rounded-full ring-2 ring-background", className)}
      style={{ background: color }}
    />
  );
}
